/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable sonarjs/cognitive-complexity */
import DescriptionIcon from "@mui/icons-material/Description";
import ExpandMore from "@mui/icons-material/ExpandMore";
import GroupIcon from "@mui/icons-material/Group";
import HomeIcon from "@mui/icons-material/Home";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { IconButton, Stack, Typography, useMediaQuery } from "@mui/material";
import Box from "@mui/material/Box/Box";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { selectUserProfile } from "../../../store/auth/selector";
import { setUserRole } from "../../../store/auth/slice";
import { layoutPrivateStyle } from "../../../styles/layout/private-routes";
import { AdminMenuProps } from "../../../types/admin-menu";
import {
  getListPrivilegeByRole,
  getRoleNameProfileSA,
} from "../../container/login/api-endpoint/callApi";

export function SideMenuAdmin({
  adminMenu,
  setAdminMenu,
  activeMenu,
  setActiveMenu,
}: AdminMenuProps) {
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [listPrivileges, setListPrivileges] = useState<string[]>();
  const [openCollapse, setOpenCollapse] = useState<string[]>([]);
  const isSmall = useMediaQuery("(min-width: 600px)");
  const [modulOpen, setModulOpen] = useState(adminMenu);
  const user = useSelector(selectUserProfile);
  const [getRole, setGetRole] = useState<string>("");
  const [isHomePage, setIsHomePage] = useState(false);

  useEffect(() => {
    setIsHomePage(location.pathname === "/");
  }, [location.pathname]);

  useEffect(() => {
    if (
      window.location.pathname === "/manage-presets/define-preset" ||
      window.location.pathname === "/dashboard/editor"
    ) {
      setModulOpen(true);
      setAdminMenu?.(true);
    }
    setActiveMenu?.(window.location.pathname);

    // get List Privileges
    const fetchApiPrivileges = async () => {
      try {
        // get all data for table list User
        const getListPrivilege = await getListPrivilegeByRole(user.Email);
        setListPrivileges(getListPrivilege);

        const getRoleNameProfile = await getRoleNameProfileSA(user.BinusianId);

        dispatch(setUserRole(getRoleNameProfile));

        setGetRole(getRoleNameProfile.roleName);
      } catch (error) {
        // Handle error if needed
        console.log("Error fetching data:", error);
      }
    };

    fetchApiPrivileges();
  }, []);

  const sideMenuModel = {
    initial1: {
      height: "100%",
      width: "240px",
    },
    initial2: {
      height: "100%",
      width: "52px",
    },
    animate1: { width: adminMenu ? "52px" : "320px" },
    animate2: { width: adminMenu ? "320px" : "52px" },
  };

  const variantSideMenu = isSmall
    ? {
        initial: sideMenuModel.initial1,
        animate: sideMenuModel.animate1,
      }
    : !modulOpen
    ? {
        initial: sideMenuModel.initial2,
        animate: sideMenuModel.animate2,
      }
    : {
        initial: sideMenuModel.initial1,
        animate: sideMenuModel.animate1,
      };

  const cardModel = {
    initial1: {
      width: "220px",
      height: "140px",
      margin: "10px 10px 20px 10px",
      overflow: "hidden",
    },
    initial2: {
      width: "40px",
      height: "140px",
      margin: "10px 6px 20px 6px",
      overflow: "hidden",
    },
    animate1: {
      width: adminMenu ? "40px" : "220px",
      margin: adminMenu ? "10px 6px 20px 6px" : "10px 10px 20px 10px",
    },
    animate2: {
      width: adminMenu ? "220px" : "40px",
      margin: adminMenu ? "10px 10px 20px 10px" : "10px 6px 20px 6px",
    },
  };

  const sideMenuTitleModul = isSmall
    ? adminMenu
      ? { display: "none" }
      : layoutPrivateStyle.sideMenuTitle
    : modulOpen
    ? !adminMenu
      ? layoutPrivateStyle.sideMenuTitle
      : { display: "none" }
    : adminMenu
    ? layoutPrivateStyle.sideMenuTitle
    : { display: "none" };

  const sideMenuIconCollapseModul = isSmall
    ? adminMenu
      ? { display: "none" }
      : layoutPrivateStyle.sideMenuIconCollapse
    : modulOpen
    ? !adminMenu
      ? layoutPrivateStyle.sideMenuIconCollapse
      : { display: "none" }
    : adminMenu
    ? layoutPrivateStyle.sideMenuIconCollapse
    : { display: "none" };

  const sideMenuCollapseModul = isSmall
    ? adminMenu
      ? { display: "none" }
      : { display: "block" }
    : modulOpen
    ? !adminMenu
      ? { display: "block" }
      : { display: "none" }
    : adminMenu
    ? { display: "block" }
    : { display: "none" };

  const sideMenuIconButtonModul = isSmall
    ? adminMenu
      ? layoutPrivateStyle.sideMenuPrivateIconButton
      : layoutPrivateStyle.sideMenuPrivateIconButtonActive
    : modulOpen
    ? !adminMenu
      ? layoutPrivateStyle.sideMenuPrivateIconButtonActive
      : layoutPrivateStyle.sideMenuPrivateIconButton
    : adminMenu
    ? layoutPrivateStyle.sideMenuPrivateIconButtonActive
    : layoutPrivateStyle.sideMenuPrivateIconButton;

  const handleOpen = () => {
    if (isSmall) setModulOpen(!modulOpen);
    setAdminMenu?.(!adminMenu);
  };

  const handleClick = (link) => {
    setActiveMenu?.(link);
    Navigate(link);
  };

  const handleCollapse = (e) => {
    if (openCollapse?.find((collapse) => collapse === e))
      setOpenCollapse?.(openCollapse?.filter((collapse) => collapse !== e));
    else setOpenCollapse((prev) => [...prev, e]);
  };

  const findCollapse = (e) => {
    if (openCollapse?.find((collapse) => collapse === e)) return true;
    return false;
  };

  // list SideMenu
  const linkLists = [
    {
      name: "Home",
      icon: <HomeIcon sx={layoutPrivateStyle.sideMenuIcon} />,
      link: "/",
      key: "Home",
      collapseList: [],
    },
    {
      name: "List of Request",
      icon: <DescriptionIcon sx={layoutPrivateStyle.sideMenuIcon} />,
      link: "/list-of-request",
      key: "List of Request",
      collapseList: [],
    },
    {
      name: "Master User",
      icon: <GroupIcon sx={layoutPrivateStyle.sideMenuIcon} />,
      link: "/master-user",
      key: "Master User",
      collapseList: [],
    },
    {
      name: "Master Role",
      icon: <ManageAccountsIcon sx={layoutPrivateStyle.sideMenuIcon} />,
      link: "/master-role",
      key: "Master Role",
      collapseList: [],
    },
    {
      name: "CRR Report",
      icon: <DescriptionIcon sx={layoutPrivateStyle.sideMenuIcon} />,
      link: "/crr-report",
      key: "CRR Report",
      collapseList: [],
    },
    {
      name: "Questionnaire Report",
      icon: <DescriptionIcon sx={layoutPrivateStyle.sideMenuIcon} />,
      link: "/questionnaire-report",
      key: "Questionnaire Report",
      collapseList: [],
    },
  ];

  const containerStyle = {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "left",
    alignItems: "left",
    marginBottom: "10px",
    paddingLeft: "15px",
    paddingRight: "15px",
  };

  const boxStyle = {
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "left",
    padding: "10px",
    borderRadius: "10px",
  };

  const boxStyleSmall = {
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "11px",
    borderRadius: "10px",
  };

  const sideMenuTextStyle = {
    width: "100%",
    color: "white",
    fontSize: "14px",
  };

  return (
    <motion.div
      key="animate-sidemenu"
      initial={variantSideMenu.initial}
      animate={variantSideMenu.animate}
    >
      <Box sx={layoutPrivateStyle.sideMenuPaperBox}>
        <IconButton
          onClick={handleOpen}
          color="primary"
          sx={sideMenuIconButtonModul}
        >
          {isSmall ? (
            !adminMenu ? (
              <KeyboardDoubleArrowLeftIcon
                sx={layoutPrivateStyle.sideMenuPrivateIcon}
              />
            ) : (
              <KeyboardDoubleArrowRightIcon
                sx={layoutPrivateStyle.sideMenuPrivateIcon}
              />
            )
          ) : modulOpen ? (
            !adminMenu ? (
              <KeyboardDoubleArrowLeftIcon
                sx={layoutPrivateStyle.sideMenuPrivateIcon}
              />
            ) : (
              <KeyboardDoubleArrowRightIcon
                sx={layoutPrivateStyle.sideMenuPrivateIcon}
              />
            )
          ) : adminMenu ? (
            <KeyboardDoubleArrowLeftIcon
              sx={layoutPrivateStyle.sideMenuPrivateIcon}
            />
          ) : (
            <KeyboardDoubleArrowRightIcon
              sx={layoutPrivateStyle.sideMenuPrivateIcon}
            />
          )}
        </IconButton>
        <Box
          sx={{
            height: "1px",
            width: "100%",
            marginBottom: "16px",
          }}
        />

        {/* tampilan sidebar profileUser */}
        <Box sx={containerStyle}>
          <Box sx={isSmall ? boxStyle : boxStyleSmall}>
            <Stack direction="row" gap="4px" alignItems="center">
              <Stack direction="row" gap="4px" alignItems="center">
                <Typography sx={sideMenuTitleModul} style={sideMenuTextStyle}>
                  Login as {getRole}
                </Typography>
              </Stack>
            </Stack>
          </Box>
        </Box>

        <List sx={{ width: "100%", padding: "0" }}>
          {linkLists.map((list) => (
            <Stack
              key={list.name}
              sx={{
                display:
                  list.key !== "" && !listPrivileges?.includes(`${list?.key}`)
                    ? "none"
                    : undefined,
              }}
            >
              <ListItemButton
                key={list.name}
                sx={
                  isHomePage
                    ? layoutPrivateStyle.sideMenuLink
                    : activeMenu?.includes(`${list.link}`) && list.link !== "/"
                    ? layoutPrivateStyle.sideMenuLinkActive
                    : findCollapse(list.name)
                    ? layoutPrivateStyle.sideMenuLinkCollapse
                    : layoutPrivateStyle.sideMenuLink
                }
                onClick={
                  list.collapseList.length === 0
                    ? () => handleClick(list.link)
                    : () => handleCollapse(list.name)
                }
              >
                <Stack direction="row" gap="4px" alignItems="center">
                  {list.icon}
                  <Typography sx={sideMenuTitleModul}>{list.name}</Typography>
                </Stack>
                {findCollapse(list.name) ? (
                  <ExpandMore sx={sideMenuIconCollapseModul} />
                ) : (
                  list.collapseList.length > 0 && (
                    <KeyboardArrowLeftIcon sx={sideMenuIconCollapseModul} />
                  )
                )}
              </ListItemButton>
            </Stack>
          ))}
        </List>
      </Box>
    </motion.div>
  );
}
